import * as v from 'valibot';
import { entityStateEventSchema } from '../types/EntityStateEvent';
import { parseJSON } from '../util/json';
import { entityStateEvent } from '../actions/EntityStateEvent';
export function handleEntityStateEvent(dispatch, eventData) {
    var _a;
    const data = parseJSON(eventData, 'entity state');
    if (data !== undefined) {
        const res = v.safeParse(entityStateEventSchema, data);
        if (res.success) {
            const d = res.output;
            const log_enabled = ((_a = localStorage.getItem('log_event_entity_states')) !== null && _a !== void 0 ? _a : '0') == '1';
            if (log_enabled) {
                console.log('entity state', d);
            }
            dispatch(entityStateEvent(d.entity_id, d.type, d.value, d.ts));
        }
    }
}
